var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#EFF3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8C15.38 8 13.25 10.13 13.25 12.75C13.25 15.32 15.26 17.4 17.88 17.49C17.96 17.48 18.04 17.48 18.1 17.49C18.12 17.49 18.13 17.49 18.15 17.49C18.16 17.49 18.16 17.49 18.17 17.49C20.73 17.4 22.74 15.32 22.75 12.75C22.75 10.13 20.62 8 18 8Z",
    fill: "#5286B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.08 20.1499C20.29 18.2899 15.74 18.2899 12.93 20.1499C11.66 20.9999 10.96 22.1499 10.96 23.3799C10.96 24.6099 11.66 25.7499 12.92 26.5899C14.32 27.5299 16.16 27.9999 18 27.9999C19.84 27.9999 21.68 27.5299 23.08 26.5899C24.34 25.7399 25.04 24.5999 25.04 23.3599C25.03 22.1299 24.34 20.9899 23.08 20.1499ZM20 24.1299H18.75V25.3799C18.75 25.7899 18.41 26.1299 18 26.1299C17.59 26.1299 17.25 25.7899 17.25 25.3799V24.1299H16C15.59 24.1299 15.25 23.7899 15.25 23.3799C15.25 22.9699 15.59 22.6299 16 22.6299H17.25V21.3799C17.25 20.9699 17.59 20.6299 18 20.6299C18.41 20.6299 18.75 20.9699 18.75 21.3799V22.6299H20C20.41 22.6299 20.75 22.9699 20.75 23.3799C20.75 23.7899 20.41 24.1299 20 24.1299Z",
    fill: "#5286B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAdminIcon);
export default __webpack_public_path__ + "static/media/add-admin-icon.1bb2e3aac62d5d6f7b8b52cae912863c.svg";
export { ForwardRef as ReactComponent };